import { Routes, Route } from "react-router-dom";
import CarriersList from "../component/transferReason/manageCarriers/CarriersList";
import SearchModal from "../component/transferReason/SearchModal";
import TransferContext from "../component/transferReason/TransferContext";
import TransferRequestDetails from "../component/transferReason/TransferRequestDetails";
import { useFormik } from "formik";
import { TransferReasonTypes } from "../component/transferReason/Types";

const TransferRequestMainPage = () => {
  const formik = useFormik<TransferReasonTypes.SearchFunctionTypes>({
    initialValues: {},
    onSubmit: () => {},
  });

  return (
    <TransferContext>
      <Routes>
        <Route path="/" element={<SearchModal formik={formik} />} />
        <Route path="/details/:id/*" element={<TransferRequestDetails />} />
        <Route path="/carriers/:id" element={<CarriersList />} />
      </Routes>
    </TransferContext>
  );
};

export default TransferRequestMainPage;
